/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Stems_Foreground_LabelInputs */



/**
* | output |
* | --- |
* | "Foreground (dialogue)" |
*
* @param {Audio_Stems_Foreground_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_stems_foreground_label = /** @type {((inputs?: Audio_Stems_Foreground_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Stems_Foreground_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Premier plan (dialogues)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vordergrund (Dialog)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Primo piano (dialoghi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Передний план (диалоги)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Primer plano (diálogo)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前景（对白）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前景（台詞）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोरग्राउंड (संवाद)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Primeiro plano (diálogo)")
	return /** @type {LocalizedString} */ ("Foreground (dialogue)")
});